import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc0bcb0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex h-[40px] items-center w-full",
  "data-testid": "agents-alerts-header"
}
const _hoisted_2 = { style: {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                } }
const _hoisted_3 = { class: "flex content-center items-center flex-nowrap" }
const _hoisted_4 = {
  key: 0,
  class: "incredicon-solid-windows !text-[20px] mr-2"
}
const _hoisted_5 = {
  key: 1,
  class: "uil uil-linux !text-[20px] mr-2"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "font-gordita-regular pl-[12px] pr-[19px] flex items-center justify-between bg-System/app_white outline outline-1 outline-System/app_border whitespace-nowrap rounded-b-[2px]" }
const _hoisted_8 = { class: "text-[11px] leading-[15px] mr-[16px] text-Text/text_medium flex items-center" }
const _hoisted_9 = {
  key: 0,
  "data-testid": "total-filtered-agents"
}
const _hoisted_10 = { class: "text-Text/text_high" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 1,
  "data-testid": "table-no-agents"
}
const _hoisted_14 = {
  key: 2,
  class: "flex items-center"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ellipsis-seperator mx-3 w-1 h-1 rounded-[50%] bg-[#374A5080]" }, null, -1))
const _hoisted_16 = { "data-testid": "total-agents" }
const _hoisted_17 = { class: "text-Text/text_high" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " in filter", -1))
const _hoisted_19 = {
  key: 3,
  class: "flex items-center mr-3"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ellipsis-seperator mx-3 w-1 h-1 rounded-[50%] bg-[#374A5080]" }, null, -1))
const _hoisted_21 = { "data-testid": "total-selected-agents" }
const _hoisted_22 = { class: "text-Text/text_high" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " selected", -1))
const _hoisted_24 = {
  key: 4,
  class: "!pa-0"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "!py-[2px] !px-[4px] font-gordita-regular text-[11px] text-Text/text_medium text-decoration-line: underline" }, " Clear all selected ", -1))
const _hoisted_26 = { class: "flex gap-8 justify-between" }
const _hoisted_27 = { class: "flex items-center gap-[23px] h-[40px] ml-auto" }
const _hoisted_28 = { class: "flex items-center gap-[8px] ml-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-gordita-regular text-[11px] text-Text/text_medium" }, "Show: ", -1))

import elementIds from '@/const/elementIds.json';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { Agent_AssignPriority, Agent_QuickFilter, Agent_SortField, Agent_SortOrder, AgentsQuery, License_RegistrationType, useAgentsPageQuery } from '@/graphql/codegen/generated/graphql';
import DynamicAgentActionMenu from '@/components/agents-table/DynamicAgentActionMenu.vue';
import { IncrediButton, IncrediPagination, IncrediSelect, IncrediTable, IncrediTooltip } from 'incredi-ui';
import { dateUtils } from '@/services/dateUtils';
import { computed, inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import AgentNameCell from '@/views/agents/components/agents-table/components/AgentRow/Cells/AgentsTableNameCell.vue';
import { useUserRolePermissions } from '@/services/UserRolePermissions/UserRolePermissions';
import AgentsTableStatusCell from '@/views/agents/components/agents-table/components/AgentRow/Cells/AgentsTableStatusCell.vue';
import AgentsAlertsHeader from '@/views/agents/components/agents-table/components/agents-alerts-header.vue';
import { useAgentsTableUtils } from '@/views/agents/components/agents-table/agent-table-list/OS/agents-table.utils';
import { IKAgentsDrawerFilter } from '@/types/injectionKeys';
import EmptyAgentsSearch from '@/components/common/empty-table-placeholder.vue';
import AgentTableNameCellCompactView from '@/views/agents/components/agents-table/components/AgentRow/Cells/AgentTableNameCellCompactView.vue';
import { useMatomo } from '@/services/matomo/matomo.service';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { Constants } from '@/const/globals';
import AgentUpTimeCell from '../../components/AgentRow/Cells/AgentsTableUpTimeCell.vue';
import { useAgentRowStyle, useAgentsTableHelpers } from '../../agents-table.helpers';
import { useAgentsTableConstants } from '../../agents-table.const';
import { ASSIGNMENT_PRIORITY_LABEL_MAP, BUILD_PRIORITY_LABEL_MAP, LOG_LEVEL_LABEL_MAP } from '../../../../agents.const';
import { IKAgentsPersistentData, IKAgentsQueryFilter } from '../../../../agents.injectionKeys';
import TableCell from '../../components/AgentRow/Cells/AgentsTableCell.vue';
import CheckboxCell from '../../components/AgentRow/Cells/AgentsTableCheckboxCell.vue';
import CellWrapper from '../../components/AgentRow/AgentTableCellWrapper.vue';
import FloatingCell from '../../components/AgentRow/Cells/AgentsTableFloatingCell.vue';
import { IKAgentsSelected } from '../../agents-table.InjectionKeys';
import HeaderCheckboxCell from '../../components/Cells/AgentsTableHeaderCheckboxCell.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'agents-table.windows',
  props: {
    columns: null,
    agentsQueryResult: null
  },
  emits: ["onScroll"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line no-unused-vars
  (e: 'onScroll', state: { isScrolling: boolean }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  columns: ReturnType<typeof useAgentsTableConstants>['columns']['value'];
  agentsQueryResult: AgentsQuery['agents'];
}

const agentsTableConstants = useAgentsTableConstants();

const matomo = useMatomo();

const agentsFilter = inject(IKAgentsDrawerFilter);
const agentsPersistedData = inject(IKAgentsPersistentData);
const agentsQueryFilter = inject(IKAgentsQueryFilter);
const selectedAgents = inject(IKAgentsSelected);
const isCompactRow = computed(() => agentsPersistedData?.getAgentsTableCompactView.value || false);
const userRolePermissions = useUserRolePermissions();


const { getAgentRowStyle } = useAgentRowStyle();
const isScrolling = ref(false);
const isNameColHovered = ref(false);
const isFloatingMenuOpen = ref<boolean>(false);
const contextMenuOpenedRowIndex = ref<number | undefined>(undefined);
const setIsScrolling = (value: boolean) => {
  if (isScrolling.value !== value) {
    isScrolling.value = value;
    emit('onScroll', { isScrolling: value });
  }
};

const { getFreeDiskSpace, getMemoryUsage } = useAgentsTableHelpers();
const store = useStore();
const isAgentMenuOpen = ref<boolean>(false);
const isNameHeaderHovered = ref(false);
const agentsTableUtils = useAgentsTableUtils();
const coordinatorsService = inject(IKCoordinatorsService);
const GQL_AgentsPageQuery = useAgentsPageQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));

const spotValue = (index: number) => {
  if (!props?.agentsQueryResult?.agents || props.agentsQueryResult.agents[index]?.cloud?.spot === null || props.agentsQueryResult.agents[index]?.cloud?.spot === undefined) {
    return null;
  }
  return props.agentsQueryResult?.agents[index]?.cloud?.spot ? 'Yes' : 'No';
};

const toggleFloatingRow = (value: boolean, index: number) => {
  isFloatingMenuOpen.value = value;
  contextMenuOpenedRowIndex.value = value ? index : undefined;
  selectedAgents?.clearSelection();
  if (props.agentsQueryResult?.agents && props.agentsQueryResult?.agents[index]) {
    agentsTableUtils.selectAgent(true, props.agentsQueryResult?.agents[index]);
  }
};

onMounted(() => {
  // Need to handle new page size options according to story WIN-15064
  if (agentsQueryFilter?.get.value?.paging?.pageSize === 75) {
    agentsQueryFilter?.set({
      ...agentsQueryFilter?.get.value,
      paging: { ...agentsQueryFilter?.get.value.paging, pageSize: 100 },
    });
  }
});

const showAgentNameTooltip = () => {
  setTimeout(() => {
    isNameHeaderHovered.value = true;
  }, 1000);
};

const handleOpenContextMenu = (index: number) => {
  if (
    props.agentsQueryResult?.agents &&
    props.agentsQueryResult?.agents[index] &&
    agentsTableUtils.shouldOpenContextMenu() &&
    !agentsTableUtils.isCloudAgentInStatusStoppedOrUpdating(props.agentsQueryResult?.agents[index])
  ) {
    if (!selectedAgents?.selectedAgentIds.value.has(props?.agentsQueryResult?.agents[index]?.id as string)) {
      selectedAgents?.clearSelection();
      if (props.agentsQueryResult?.agents && props.agentsQueryResult?.agents[index]) {
        agentsTableUtils.selectAgent(true, props.agentsQueryResult?.agents[index]);
      }
      isAgentMenuOpen.value = true;
      contextMenuOpenedRowIndex.value = index;
    } else if (selectedAgents?.selectedAgentIds.value.size === 1) {
      isAgentMenuOpen.value = true;
      contextMenuOpenedRowIndex.value = index;
    } else if (selectedAgents?.selectedAgentIds.value.size > 1) {
      isAgentMenuOpen.value = true;
      contextMenuOpenedRowIndex.value = undefined;
    }
  }
  matomo?.trackEvent({
    category: 'Menu Open',
    action: 'Right click/ 3 dots',
  });
};

const clearFilters = () => {
  agentsFilter?.clearFilters();
  agentsFilter?.setGQL_AgentsQuickFilter('showAll');
  agentsFilter?.setGQL_AgentsSearchFilter('');
  agentsFilter?.clearGQL_AgentsFilter();
};

const totalFilteredAgentsCount = computed(() => props.agentsQueryResult?.totalFilteredCount || 0);
const isSearchFilterApplied = computed(() => !!agentsFilter?.GQL_AgentsFilter?.value?.searchFilter);
const totalAgentsCount = computed(() => props.agentsQueryResult?.totalCount || 0);
const isSCL = computed(() => GQL_AgentsPageQuery?.result?.value?.ibManagerEntities?.license?.windows?.features?.productFeatures?.includes(Constants.LICENSE_FEATURES.SCL));

const showAgentsTotalInFiltersCount = computed(
  () =>
    totalAgentsCount.value - totalFilteredAgentsCount.value ||
    agentsFilter?.agentsLeftDrawerActiveFilters.value ||
    (agentsFilter?.GQL_AgentsFilter?.value?.quickFilter && agentsFilter?.GQL_AgentsFilter?.value?.quickFilter !== Agent_QuickFilter.All) ||
    agentsFilter?.GQL_AgentsFilter.value.searchFilter,
);

const buildCacheEndpointText = (index: number) => ({
  title: props.agentsQueryResult?.agents?.[index]?.buildCacheSettings?.cacheSettingsDisplay?.cacheType,
  subtitle: props.agentsQueryResult?.agents?.[index]?.buildCacheSettings?.cacheSettingsDisplay?.cacheRemoteValue,
});

return (_ctx: any,_cache: any) => {
  return (_unref(agentsQueryFilter)?.get.value && _unref(agentsQueryFilter)?.set)
    ? (_openBlock(), _createBlock(IbxScopedCss, {
        key: 0,
        class: "flex-grow flex flex-col flex-nowrap"
      }, {
        default: _withCtx(() => [
          _createVNode(DynamicAgentActionMenu, {
            "agents-query-result": __props.agentsQueryResult,
            "context-menu": isAgentMenuOpen.value && !_unref(store).getters['settings/isBackupCoordinator'],
            "before-hide": 
        () => {
          isAgentMenuOpen.value = false;
          contextMenuOpenedRowIndex.value = undefined;
        }
      
          }, null, 8, ["agents-query-result", "context-menu", "before-hide"]),
          (_unref(totalFilteredAgentsCount))
            ? (_openBlock(), _createBlock(_unref(IncrediTable), {
                key: 0,
                "model-value": {
        selection: _unref(userRolePermissions).authorize?.value?.agents.enabled.actions
          ? {
              itemId: 'id',
              items: _unref(selectedAgents)?.selectedAgentIds.value || new Set(),
            }
          : undefined,
        sort: {
          name: _unref(agentsTableConstants).mapAgentSortFieldToColumns.value[_unref(agentsQueryFilter)?.get.value.sort.field],
          descending: _unref(agentsQueryFilter)?.get.value.sort.order === _unref(Agent_SortOrder).Descending,
        },
      },
                "sort-name": _unref(agentsQueryFilter)?.get.value.sort.field,
                "sort-descending": _unref(agentsQueryFilter)?.get.value.sort.order === _unref(Agent_SortOrder).Descending,
                "row-height": _unref(isCompactRow) ? 32 : 48,
                "data-testid": _unref(elementIds).agents.AgentsTable,
                class: _normalizeClass(["agents-table flex-grow w-full h-0", {
        'pointer-events-none': isFloatingMenuOpen.value || isAgentMenuOpen.value,
        'alerts-column-header-hovered': _unref(agentsQueryFilter)?.get.value.sort.field !== _unref(Agent_SortField).Name && isNameColHovered.value,
        'alerts-column-header-hovered--name-sorted': _unref(agentsQueryFilter)?.get.value.sort.field === _unref(Agent_SortField).Name && isNameColHovered.value,
      }]),
                columns: __props.columns,
                items: (__props.agentsQueryResult?.agents as any) || [],
                "header-tooltip": true,
                "hovered-row-prop": contextMenuOpenedRowIndex.value,
                onOnDrag: _cache[6] || (_cache[6] = state => setIsScrolling(state)),
                onOnChangeColumnsWidth: _cache[7] || (_cache[7] = col => _unref(agentsTableUtils).updateColumnWidth(col)),
                onOnScroll: _cache[8] || (_cache[8] = state => setIsScrolling(state.isScrolling?.value)),
                "onUpdate:modelValue": _cache[9] || (_cache[9] = 
          tableState => {
            if (!_unref(agentsQueryFilter)) return;
            _unref(agentsTableUtils).handlePageSorting(
              _unref(agentsTableConstants).mapColumnsToAgentSortField.value[tableState.sort?.name as keyof typeof agentsTableConstants['mapColumnsToAgentSortField']['value']],
              tableState.sort?.descending ? _unref(Agent_SortOrder).Descending : _unref(Agent_SortOrder).Ascending
             )
            _unref(agentsTableUtils).handleAgentsSelection(tableState, __props.agentsQueryResult);
          }
        )
              }, {
                "header-checkbox": _withCtx(({ bind, on }) => [
                  _createVNode(HeaderCheckboxCell, {
                    "data-testid": _unref(elementIds).agents.table.selectAllCheckbox,
                    "model-value": bind.modelValue,
                    "onUpdate:modelValue": newValue => on['update:model-value'](newValue)
                  }, null, 8, ["data-testid", "model-value", "onUpdate:modelValue"])
                ]),
                "header-AgentName": _withCtx(({ column }) => [
                  _createVNode(_unref(IncrediTooltip), {
                    "model-value": isNameHeaderHovered.value,
                    direction: "top-middle",
                    "offset-x": 25,
                    "offset-y": -2,
                    delay: 1000
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(column.name), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(AgentsAlertsHeader, {
                          class: "w-[36px] h-[40px]",
                          "model-value": _unref(agentsQueryFilter)?.get.value.sort,
                          onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (isNameColHovered.value = true)),
                          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isNameColHovered.value = false)),
                          "onUpdate:sort": _cache[2] || (_cache[2] = sort => _unref(agentsQueryFilter)?.set({ ..._unref(agentsQueryFilter)?.get.value, sort }))
                        }, null, 8, ["model-value"]),
                        _createElementVNode("div", {
                          class: "ml-3 w-[calc(100%-48px)] truncate",
                          onMouseenter: showAgentNameTooltip,
                          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (isNameHeaderHovered.value = false)),
                          onFocusin: showAgentNameTooltip,
                          onFocusout: _cache[4] || (_cache[4] = ($event: any) => (isNameHeaderHovered.value = false)),
                          onClick: _cache[5] || (_cache[5] = 
                () =>
                  _unref(agentsQueryFilter)?.set({
                    ..._unref(agentsQueryFilter)?.get.value,
                    sort: {
                      field: _unref(Agent_SortField).Name,
                      order:
                        _unref(agentsQueryFilter)?.get.value.sort.field === _unref(Agent_SortField).Name
                          ? _unref(agentsQueryFilter)?.get.value.sort.order === _unref(Agent_SortOrder).Ascending
                            ? _unref(Agent_SortOrder).Descending
                            : _unref(Agent_SortOrder).Ascending
                          : _unref(Agent_SortOrder).Ascending,
                    },
                  })
              )
                        }, [
                          _createElementVNode("span", _hoisted_2, _toDisplayString(column.name), 1)
                        ], 32)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["model-value"])
                ]),
                "content-checkbox": _withCtx(({ index, bind }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CheckboxCell, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        disabled: __props.agentsQueryResult?.agents && _unref(agentsTableUtils).isCloudAgentInStatusStoppedOrUpdating(__props.agentsQueryResult?.agents[index] || {}),
                        "model-value": bind['model-value'],
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        "onUpdate:modelValue": 
            newValue => {
              if (__props.agentsQueryResult?.agents && __props.agentsQueryResult?.agents[index]) _unref(agentsTableUtils).selectAgent(newValue, __props.agentsQueryResult?.agents[index]);
            }
          
                      }, null, 8, ["data-cy-agent-name", "disabled", "model-value", "agent-metadata", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                "floating-row": _withCtx(({ index, hoveredRow }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.floatingRow,
                        floating: "",
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          ((index === hoveredRow || contextMenuOpenedRowIndex.value === index) && !_unref(agentsTableUtils).isCloudAgentInStatusStoppedOrUpdating(__props.agentsQueryResult?.agents[index] || {}))
                            ? (_openBlock(), _createBlock(FloatingCell, {
                                key: 0,
                                agent: __props.agentsQueryResult?.agents[index],
                                onToggleRow: (value) => toggleFloatingRow(value, index)
                              }, null, 8, ["agent", "onToggleRow"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-AgentName": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents && __props.agentsQueryResult?.agents[index] && !_unref(isCompactRow))
                    ? (_openBlock(), _createBlock(AgentNameCell, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.nameCell,
                        class: "h-full",
                        "agent-row-style": _unref(getAgentRowStyle)(__props.agentsQueryResult?.agents[index] || {}, !!_unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')),
                        "agent-data": __props.agentsQueryResult?.agents[index] as any,
                        onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                      }, null, 8, ["data-cy-agent-name", "data-testid", "agent-row-style", "agent-data", "onContextmenu"]))
                    : _createCommentVNode("", true),
                  (__props.agentsQueryResult?.agents && __props.agentsQueryResult?.agents[index] && _unref(isCompactRow))
                    ? (_openBlock(), _createBlock(AgentTableNameCellCompactView, {
                        key: 1,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.nameCell,
                        class: "h-full",
                        "agent-row-style": _unref(getAgentRowStyle)(__props.agentsQueryResult?.agents[index] || {}, !!_unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')),
                        "agent-data": __props.agentsQueryResult?.agents[index] as any,
                        onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                      }, null, 8, ["data-cy-agent-name", "data-testid", "agent-row-style", "agent-data", "onContextmenu"]))
                    : _createCommentVNode("", true)
                ]),
                "content-Status": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.statusCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(AgentsTableStatusCell, {
                            "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                            value: __props.agentsQueryResult?.agents[index]?.status as any,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["agent-metadata", "value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-AgentDescription": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.descriptionCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.hostComment,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-IP": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.ipCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.ip,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-License": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.licenseCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.license?.initiatorType,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-BuildGroup": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.buildGroupCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.metadata?.isCloud ? null : __props.agentsQueryResult?.agents[index]?.buildGroup,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-UsedHelpersCache": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.usedHelpersCacheCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (!_unref(agentsTableUtils).isCloudAgentInStatusStoppedOrUpdating(__props.agentsQueryResult?.agents[index] || {}))
                            ? (_openBlock(), _createBlock(TableCell, {
                                key: 0,
                                value: Math.trunc(__props.agentsQueryResult?.agents[index]?.performance?.cacheUsed || 0) + '/' + Math.trunc(__props.agentsQueryResult?.agents[index]?.performance?.cacheSize || 0) + ' MB',
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, null, 8, ["value", "onContextmenu"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-LastConnected": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.lastConnectedCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (__props.agentsQueryResult?.agents[index]?.lastConnected)
                            ? (_openBlock(), _createBlock(TableCell, {
                                key: 0,
                                value: _unref(dateUtils).getFormattedDate(Number(__props.agentsQueryResult?.agents[index]?.lastConnected)) + ' ' + _unref(dateUtils).getFormattedTime(Number(__props.agentsQueryResult?.agents[index]?.lastConnected)),
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, null, 8, ["value", "onContextmenu"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-AvailableCPU": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.availableCPUCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (!_unref(agentsTableUtils).isCloudAgentInStatusStoppedOrUpdating(__props.agentsQueryResult?.agents[index] || {}))
                            ? (_openBlock(), _createBlock(TableCell, {
                                key: 0,
                                value: `${__props.agentsQueryResult?.agents[index]?.performance?.availCPU}%`,
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, null, 8, ["value", "onContextmenu"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-UpDowntime": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents && __props.agentsQueryResult?.agents[index])
                    ? (_openBlock(), _createBlock(AgentUpTimeCell, {
                        key: `${__props.agentsQueryResult?.agents[index]?.lastConnected}-${index}`,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.upDowntimeCell,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false,
                        agent: __props.agentsQueryResult?.agents[index],
                        onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                      }, null, 8, ["data-cy-agent-name", "data-testid", "selected", "agent", "onContextmenu"]))
                    : _createCommentVNode("", true)
                ]),
                "content-LoggedOnUser": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.loggedOnUserCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.loggedUsers,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-FreeDiskSpace": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.freeDiskSpaceCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (__props.agentsQueryResult?.agents[index]?.performance?.totalDisk && __props.agentsQueryResult?.agents[index]?.performance?.availDisk)
                            ? (_openBlock(), _createBlock(TableCell, {
                                key: 0,
                                value: `${_unref(getFreeDiskSpace)(__props.agentsQueryResult?.agents[index] as any).available}/${_unref(getFreeDiskSpace)(__props.agentsQueryResult?.agents[index] as any).total } GB`,
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, null, 8, ["value", "onContextmenu"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-AvailableMemory": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.availableMemoryCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (!_unref(agentsTableUtils).isCloudAgentInStatusStoppedOrUpdating(__props.agentsQueryResult?.agents[index] || {}))
                            ? (_openBlock(), _createBlock(TableCell, {
                                key: 0,
                                value: `${_unref(getMemoryUsage)(__props.agentsQueryResult?.agents[index] as any).available}/${_unref(getMemoryUsage)(__props.agentsQueryResult?.agents[index] as any).total } GB`,
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, null, 8, ["value", "onContextmenu"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-BuildPriority": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.buildPriorityCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(BUILD_PRIORITY_LABEL_MAP)[__props.agentsQueryResult?.agents[index]?.buildPriority as keyof typeof BUILD_PRIORITY_LABEL_MAP],
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-AssignmentPriority": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.assignmentPriorityCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(ASSIGNMENT_PRIORITY_LABEL_MAP)[__props.agentsQueryResult?.agents[index]?.assignPriority as Agent_AssignPriority],
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-LogLevel": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.logLevelCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(LOG_LEVEL_LABEL_MAP)[__props.agentsQueryResult?.agents[index]?.logLevel as keyof typeof LOG_LEVEL_LABEL_MAP],
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-OperatingSystem": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.osSystemCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                (_unref(isSCL))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass(__props.agentsQueryResult?.agents[index]?.metadata?.isOffline ? 'text-Text/text_lowest' : 'text-Text/text_medium')
                                    }, [
                                      (__props.agentsQueryResult?.agents[index]?.metadata?.isWindowsAgent)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                                        : (__props.agentsQueryResult?.agents[index]?.osVersion)
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                                          : _createCommentVNode("", true)
                                    ], 2))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", null, _toDisplayString(__props.agentsQueryResult?.agents[index]?.metadata?.isSCL ? _ctx.$t('generic.sclTitleForLinux') : __props.agentsQueryResult?.agents[index]?.osVersion), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-BuildCacheAllocated": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.buildCacheCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (typeof __props.agentsQueryResult?.agents[index]?.license?.buildCacheAllowed === 'boolean')
                            ? (_openBlock(), _createBlock(TableCell, {
                                key: 0,
                                value: __props.agentsQueryResult?.agents[index]?.license?.buildCacheAllowed ? 'Yes' : 'No',
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, null, 8, ["value", "onContextmenu"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-BuildCacheEndpoint": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.buildCacheEndpoint,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(buildCacheEndpointText(index).title), 1),
                              (!_unref(isCompactRow))
                                ? (_openBlock(), _createElementBlock("br", _hoisted_6))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", {
                                class: _normalizeClass([__props.agentsQueryResult?.agents[index]?.metadata?.isOffline ? 'text-Text/text_lowest' : 'text-Text/text_medium', "font-gordita-regular"])
                              }, _toDisplayString(_unref(isCompactRow) && buildCacheEndpointText(index).subtitle ? ' ' + buildCacheEndpointText(index).subtitle : buildCacheEndpointText(index).subtitle), 3)
                            ]),
                            _: 2
                          }, 1032, ["onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-CPUInfo": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.cpuInfoCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.performance?.cpuInfo,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-RoutingIP": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.routingIPCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.routingIP,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-Network": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.networkCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.networkInfo,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-PhysicalCores": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.physicalCoresCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.performance?.cpuPhysical,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-LogicalCores": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.logicalCoresCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.performance?.cpuLogical,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-RegisteredHelperCores": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.registeredCoresCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.license?.helperType !== _unref(License_RegistrationType).None ? __props.agentsQueryResult?.agents[index]?.license?.registeredCores : '',
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-Port": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.port,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-MACAddress": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.macAddressCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.macAddress,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-VMType": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(agentsTableUtils).getContentForCloudStoppedAgents(__props.agentsQueryResult?.agents[index] || {}, __props.agentsQueryResult?.agents[index]?.cloud?.vmType),
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-Spot": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(agentsTableUtils).getContentForCloudStoppedAgents(__props.agentsQueryResult?.agents[index] || {}, spotValue(index)),
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-HDType": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(agentsTableUtils).getContentForCloudStoppedAgents(__props.agentsQueryResult?.agents[index] || {}, __props.agentsQueryResult?.agents[index]?.cloud?.hdType),
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-VolumeSize": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(agentsTableUtils).getCloudAgentVolumeSize(__props.agentsQueryResult?.agents[index] || {}),
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-CacheSize": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(agentsTableUtils).getCloudCacheSize(__props.agentsQueryResult?.agents[index] || {}),
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-AvailabilityZone": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(agentsTableUtils).getContentForCloudStoppedAgents(__props.agentsQueryResult?.agents[index] || {}, __props.agentsQueryResult?.agents[index]?.cloud?.zone),
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-CloudCores": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.cloud?.numberOfCores || '',
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-CacheCluster": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.cluster || '',
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model-value", "sort-name", "sort-descending", "row-height", "data-testid", "class", "columns", "items", "hovered-row-prop"]))
            : (_openBlock(), _createBlock(EmptyAgentsSearch, {
                key: 1,
                "search-items-name": "agents",
                "has-filters-applied": _unref(isSearchFilterApplied),
                class: "flex-grow w-full bg-System/app_white border-System/app_border border",
                onClearFilters: clearFilters
              }, null, 8, ["has-filters-applied"])),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_unref(totalAgentsCount))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(totalAgentsCount)?.toLocaleString()), 1),
                    (_unref(totalAgentsCount) === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, " agent"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, " total agents"))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, " No agents for display ")),
              (_unref(showAgentsTotalInFiltersCount))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(totalFilteredAgentsCount)?.toLocaleString()), 1),
                      _hoisted_18
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(selectedAgents)?.selectedAgentIds.value.size)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(selectedAgents)?.selectedAgentIds.value.size), 1),
                      _hoisted_23
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(selectedAgents)?.selectedAgentIds.value.size)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createVNode(_unref(IncrediButton), {
                      "data-testid": "clear-all-selected-agents",
                      design: "master",
                      size: "small",
                      class: "!p-0",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(selectedAgents)?.clearSelection()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_unref(IncrediPagination), {
                  "model-value": _unref(agentsQueryFilter).get.value.paging.pageNumber,
                  "page-size": Math.ceil((_unref(totalFilteredAgentsCount) || 0) / _unref(agentsQueryFilter).get.value.paging.pageSize),
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = (pageNumber) => { _unref(agentsQueryFilter) &&  _unref(agentsQueryFilter).set({ ..._unref(agentsQueryFilter)?.get.value, paging: { ..._unref(agentsQueryFilter).get.value.paging, pageNumber } }) })
                }, null, 8, ["model-value", "page-size"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode(_unref(IncrediSelect), {
                  "model-value": _unref(agentsQueryFilter).get.value.paging.pageSize,
                  direction: "top-middle",
                  size: "tiny",
                  "min-width": 70,
                  items: [50, 100, 150, 200],
                  "override-style": {
              height: '28px',
              paddingLeft: '8px',
              paddingRight: '9px',
            },
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = pageSize=>_unref(agentsTableUtils).handlePageResize(pageSize as typeof agentsQueryFilter.get.value.paging.pageSize))
                }, null, 8, ["model-value"])
              ])
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})